import { Component, ElementRef, ViewContainerRef } from '@angular/core'
import { Router } from '@angular/router'
import { RoutingService, RouterState } from '@spartacus/core'
import { LaunchDialogService } from '@spartacus/storefront'
import { Observable } from 'rxjs'
import { map, take } from 'rxjs/operators'
import { EbAuthStatePersistenceService } from '../../../auth/services/eb-auth-state-persistence.service'
import { EbAuthService } from '../../../auth/services/eb-auth.service'
import { EbFavorites } from '../../interfaces/eb-favorites.interface'
import { EbFavoritesService } from '../../services/facades/eb-favorites.service'

@Component({
    selector: 'eb-favorites-list',
    templateUrl: './eb-favorites-list.component.html',
    styleUrls: ['./eb-favorites-list.component.scss'],
    standalone: false
})
export class EbFavoritesListComponent {
  public lists$: Observable<EbFavorites[]>
  public listsLoading$: Observable<boolean>

  constructor(
    private readonly favoritesService: EbFavoritesService,
    private readonly routingService: RoutingService,
    protected router: Router,
    protected modalService: LaunchDialogService,
    protected authService: EbAuthService,
    protected authStateService: EbAuthStatePersistenceService,
    protected vcr: ViewContainerRef,
    protected ebElement: ElementRef
  ) {}

  ngOnInit() {
    this.listsLoading$ = this.favoritesService.listLoading$
    this.lists$ = this.favoritesService.getLists()
  }

  showDetails(list: EbFavorites) {
    this.router.navigate([
      `my-account/favorites/${list.shared ? 'shared' : 'private'}/${list.code}`
    ])
  }

  deleteFavoritesList(list: EbFavorites) {
    if (!list.recommendationsList) {
      this.favoritesService.removeFavorites(list)
    }
  }

  createNewFavoritesList() {
    this.authService
      .isUserLoggedIn()
      .pipe(take(1))
      .subscribe(loggedIn => {
        if (loggedIn) {
          const dialog = this.modalService.openDialog(
            'CREATE_FAVORITE_LIST',
            this.ebElement,
            this.vcr
          )
          dialog?.pipe(take(1)).subscribe()
        } else {
          this.authStateService.internalLogout(false, '/')
        }
      })
  }

  isSelected(listId: string, isRecommendation: boolean) {
    return this.routingService.getRouterState().pipe(
      map(routingData => {
        const idFromRoute = routingData?.state?.params?.listId
          ? routingData?.state?.params?.listId
          : this.isRecommendationsSelected(routingData)
        return (isRecommendation && !idFromRoute) || idFromRoute === listId
      })
    )
  }

  isRecommendationsSelected(routingData: RouterState) {
    return routingData.state.url.split('/').pop() === 'favorites'
      ? undefined
      : routingData.state.url.split('/').pop()
  }
}
